export default {
  // 事件分析相关
  'event_details': "Event details",
  'event_title': "Title",
  'event_type': "Event Type",
  'event_description': "Description",
  'event_link': "Link",
  'event_creator': "Creator",
  'event_system': "Platform",
  'event_info_title': "Events",
  'event_info_start_title': 'Events starting today',
  'event_info_today_title': "Events occurring today",
  'event_info_events': "events",
  'event_info_subtitle': "See details for more events",
  'event_view_link': "View Link",
  'event_add': 'Add',
  
  // 事件添加模态框
  'event_modal_add_event': "Add Event",
  'event_modal_edit_event': "Edit Event",
  'event_modal_date': "Date",
  'event_modal_title': "Title",
  'event_modal_title_placeholder': "Please input the Title",
  'event_modal_country': "Country",
  'event_modal_platform': 'Platform',
  'event_modal_all': 'All',
  'event_modal_country_global': "Global",
  'event_modal_dashboard': "Dashboard",
  'event_modal_dashboard_placeholder': "Please select the Dashboard",
  'event_modal_event_type': "Event Type",
  'event_modal_event_type_placeholder': "Please select the Event Type",
  'event_modal_description': "Description",
  'event_modal_description_placeholder': "Please enter the event description, for example, the launch of XX activity resulted in the increase in DAU.",
  'event_modal_link': "Link",
  'event_modal_link_placeholder': "Please input the Link",
  'event_modal_customize_placeholder': "Please Enter Type",
  'event_left_menu_management': 'Event Management',
  'event_more': 'More',
  'event_delete_event': 'Delete The Event?',
  'event_delete_sure': 'Are you sure to delete {name}？The delete operation is irrevocable,Please confirm the operation.',
  'event_delete_success': 'Delete Event Successfully',
  'event_delete_error': 'Delete Event Failed',
  'event_after_time': 'After',
  'event_Actions': 'Actions',
  'event_add_success': 'Add Event Successfully',
  'event_edit_success': 'Edit Event Successfully',
  'event_add_fail': 'Add Event Failed',
  'event_edit_fail': 'Edit Event Failed',
  'event_selector_global_message': 'Show all events within the filtered date',
  
};
